import Speakers1 from "./Speakers1";

const speakers = {
    1: Speakers1
};

export default speakers;